require('./modules/global.js');
require('./modules/modal.js');
require('./modules/header.js');
require('./modules/contentful.js');
require('./modules/gallery.js');
require('./modules/masonry.js');
require('./modules/masonry-search.js');
require('./modules/carousel.js');
require('./modules/video.js');
require('./modules/tabs.js');
require('./modules/maps.js');
require('./modules/accordion.js');
require('./modules/downloads.js');
require('./modules/varieties.js');
require('./modules/mug-form.js');
require('./modules/trial-details.js');